const handleMileStone = (state = {}, action) => {
    switch (action.type) {
      case 'SET_MILESTONE':
        return state  = action.data;
      default:
        return state;
    }
  };
  
  export default handleMileStone;